import { Link } from "react-router-dom";

export default function OrderCancel() {
  return (
    <main data-testid="order-cancel-page" className="pt-40 pb-32 px-4 sm:px-8 lg:px-16 min-h-screen text-center">
      <p className="mono text-xs tracking-[0.25em] text-[#FF334B] uppercase">Checkout Cancelled</p>
      <h1 className="font-display font-extrabold tracking-tighter uppercase text-3xl sm:text-4xl mt-4">Nothing was charged</h1>
      <p className="text-zinc-400 text-sm mt-4 font-light">Your bag is exactly where you left it.</p>
      <Link
        to="/shop"
        data-testid="cancel-return-shop-button"
        className="inline-block mt-10 bg-[#FF334B] text-white px-8 py-4 mono text-xs tracking-[0.25em] uppercase hover:bg-[#d92339] transition-colors"
      >
        Return to Catalog
      </Link>
    </main>
  );
}
